import { render, staticRenderFns } from "./FeaturedProductsScreen.vue?vue&type=template&id=56b22040&scoped=true&"
import script from "./FeaturedProductsScreen.vue?vue&type=script&lang=js&"
export * from "./FeaturedProductsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b22040",
  null
  
)

export default component.exports